<template>
  <el-table :data="pileDataTable" stripe style="width: 100%" ref="pileDataTable" border
            v-loading="listLoading">
    <!--                <af-table-column type="selection" width="30"></af-table-column>-->
    <af-table-column prop="pileCode" :label="$t('deviceControl.pileId')"></af-table-column>
    <af-table-column prop="name" :label="$t('deviceControl.name')"></af-table-column>
    <af-table-column prop="stationName" :label="$t('deviceControl.stationName')"></af-table-column>
    <af-table-column prop="operatorName" :label="$t('deviceControl.operatorId')"></af-table-column>
    <af-table-column prop="pileTypeModel" :label="$t('xing-hao-0')"></af-table-column>
    <af-table-column width="80" prop="fastOrSlow.message" :label="$t('deviceControl.currentType')"></af-table-column>
    <af-table-column width="80" prop="ratedPower" :label="$t('gong-shuai-kw-1')"></af-table-column>
    <af-table-column width="70" prop="gunCount" :label="$t('qiang-kou-shu-liang')"></af-table-column>
    <af-table-column width="140" prop="serviceBillingRulesName" :label="$t('siteManager.serviceBillingRulesName')"></af-table-column>
    <!--                <af-table-column width="120" label="运行状态">-->
    <!--                  <template slot-scope="{row}">-->
    <!--                    <div v-if="row.runStatus">-->
    <!--                      <el-tag :type="row.runStatus.code | statusFilter">-->
    <!--                        {{ row.runStatus.message }}-->
    <!--                      </el-tag>-->
    <!--                    </div>-->
    <!--                  </template>-->
    <!--                </af-table-column>-->
    <af-table-column :label="$t('deviceControl.operation')" width="240px">
      <template slot-scope="scope">
        <el-button size="mini" plain @click="showViewVisible(scope.$index, scope.row)"
                   v-if="checkPermission(['bee:res:pile:saveOrUpdatePile'])">{{ $t('siteManager.view') }}
        </el-button>
        <el-button size="mini" @click="pileEdit(scope.$index, scope.row)"
                   v-if="checkPermission(['bee:res:pile:editPile'])">{{ $t('alaramMonitor.edit') }}
        </el-button>
        <el-button size="mini" type="danger" @click="pileDelete(scope.$index, scope.row)"
                   v-if="checkPermission(['bee:res:pile:deletePile'])">{{ $t('deviceControl.delete') }}
        </el-button>
      </template>
    </af-table-column>
  </el-table>
</template>

<script>
  export default {
    name: "list",
    data(){
      return{

      }
    },
    props:{
      pileDataTable:{},
      listLoading:false,
    },
    methods:{
      showViewVisible(index,row){
        this.$emit("showViewVisible",index,row)
      },
      pileEdit(index,row){
        this.$emit("pileEdit",index,row)
      },
      pileDelete(index,row){
        this.$emit("pileDelete",index,row)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/deviceManager/list.vue